import { ReactNode } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface FieldRowProps {
  label: string;
  value?: string | ReactNode;
  /** Compact single-line mode: renders "Label: Value" inline. */
  inline?: boolean;
}

export default function FieldRow({ label, value, inline = false }: FieldRowProps) {
  if (inline) {
    return (
      <Typography component="span" sx={{ fontSize: "12px", lineHeight: "16px", color: "#666" }}>
        {label}:{" "}
        {typeof value === "string" || value == null ? (
          <Typography
            component="span"
            sx={{ fontSize: "12px", lineHeight: "16px", color: "#1A1A1A", fontWeight: 500 }}
          >
            {value ?? "—"}
          </Typography>
        ) : (
          value
        )}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
      <Typography
        sx={{
          fontSize: "10px",
          fontWeight: 500,
          color: "#666",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          width: "40%",
          flexShrink: 0,
          lineHeight: "18px",
        }}
      >
        {label}
      </Typography>
      {typeof value === "string" || value == null ? (
        <Typography
          sx={{
            fontSize: "13px",
            color: "#1A1A1A",
            flex: 1,
            lineHeight: "18px",
          }}
        >
          {value ?? "—"}
        </Typography>
      ) : (
        <Box sx={{ flex: 1 }}>{value}</Box>
      )}
    </Box>
  );
}
